// extracted by mini-css-extract-plugin
export default {"page":"app_page__nyEY-"};